module.exports = __webpack_public_path__ + "static/media/appstore-badge.cd2bf362.svg";